import { Mail } from 'lucide-react';
import type { ReactElement } from 'react';

interface ResetSentScreenProps {
  email: string;
  devResetToken: string | null;
  onBackToSignIn: () => void;
}

export function ResetSentScreen({
  email,
  devResetToken,
  onBackToSignIn,
}: ResetSentScreenProps): ReactElement {
  return (
    <div className="min-h-dvh bg-theme-bg flex flex-col">
      <header className="p-6">
        <h1 className="text-2xl font-bold text-white">Parlay Picker</h1>
        <p className="text-theme-text-secondary">AI-powered basketball prop analysis</p>
      </header>

      <main className="flex-1 flex items-center justify-center px-6 pb-12">
        <div className="w-full max-w-md">
          <div className="bg-theme-surface rounded-lg p-6 border border-theme-border text-center">
            <div className="w-16 h-16 bg-theme-success rounded-full flex items-center justify-center mx-auto mb-4">
              <Mail className="w-8 h-8 text-white" />
            </div>
            <h2 className="text-xl font-bold text-white mb-2">Check Your Email</h2>
            <p className="text-theme-text-secondary mb-4">
              If an account exists for {email}, you'll receive a password reset link shortly.
            </p>

            {devResetToken && (
              <div className="mb-4 p-3 bg-theme-warning/50 border border-theme-warning rounded text-theme-warning text-sm text-left">
                <p className="font-medium mb-1">Dev Mode - Reset Token:</p>
                <code className="text-xs break-all">{devResetToken}</code>
              </div>
            )}

            <button
              type="button"
              onClick={onBackToSignIn}
              className="text-theme-primary hover:text-theme-primary-hover text-sm"
            >
              Back to Sign In
            </button>
          </div>
        </div>
      </main>
    </div>
  );
}
